  // ACCORDION
  var acc = document.getElementsByClassName("accordion-prd");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {

      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }
  }
 // acc[0].onclick();
 